import React from 'react';

/**
 * Dashboard page content.
 */
export function DashboardPageContent({ children }: any) {
  return (
    <div
      className="dashboard__page-content"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
      }}
    >
      {children}
    </div>
  );
}
